<script lang="ts" setup>
import { useModalsStore } from '@/stores/modals';
import { computed } from 'vue';

import { storeToRefs } from 'pinia';
import { ref } from 'vue';

function redirect(){
    window.location.href = 'http://www.google.com';
}

</script>

<template src="./modal-blockedregion.html"></template>